
import { useState, useCallback } from 'react';
import { usernameValidationService } from '@/services/usernameValidationService';

export const useUsernameValidation = (currentUsername?: string) => {
  const [isValidating, setIsValidating] = useState(false);
  const [validationError, setValidationError] = useState<string | null>(null);
  const [isValid, setIsValid] = useState(true);

  const validateUsername = useCallback(async (username: string) => {
    setIsValidating(true);
    setValidationError(null);

    try {
      const result = await usernameValidationService.validateUsername(username, currentUsername);
      
      setIsValid(result.isValid);
      setValidationError(result.message || null);
      
      return result;
    } catch (error) {
      console.error('Username validation error:', error);
      setIsValid(false);
      setValidationError('Error validating username. Please try again.');
      return { isValid: false, message: 'Error validating username. Please try again.' };
    } finally {
      setIsValidating(false);
    }
  }, [currentUsername]);

  const clearValidation = useCallback(() => {
    setValidationError(null);
    setIsValid(true);
  }, []);

  return {
    validateUsername,
    isValidating,
    validationError,
    isValid,
    clearValidation
  };
};
